import React, { useEffect, useState } from "react";
import api, { apiError } from "@/api";
import { useAuth } from "@/context/AuthContext";
import { DataTable } from "@/components/DataTable";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const empty = { name: "", phone: "", address: "" };

export default function Customers() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);
  const canEdit = ["sales", "admin"].some((r) => user.roles.includes(r));

  const load = async () => setRows((await api.get("/customers")).data);
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    try {
      if (editId) await api.put(`/customers/${editId}`, form);
      else await api.post("/customers", form);
      toast.success("Customer disimpan"); setOpen(false); load();
    } catch (e) { toast.error(apiError(e)); }
  };

  const columns = [
    { key: "name", label: "Nama", render: (r) => <span className="font-semibold text-slate-900">{r.name}</span> },
    { key: "phone", label: "No. Telepon", mono: true, render: (r) => (
      <a href={`https://wa.me/${r.phone.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-emerald-700 hover:underline">
        <MessageCircle className="w-3.5 h-3.5" /> {r.phone}
      </a>
    ), raw: (r) => r.phone },
    { key: "address", label: "Alamat" },
    { key: "order_count", label: "Total Order", mono: true },
    { key: "actions", label: "", sortable: false, noExport: true, render: (r) => canEdit && (
      <Button size="sm" variant="outline" className="h-8" data-testid={`edit-customer-${r.id}`} onClick={() => { setForm({ name: r.name, phone: r.phone, address: r.address }); setEditId(r.id); setOpen(true); }}>Edit</Button>
    ) },
  ];

  return (
    <div>
      <PageHeader title="Customer" subtitle="Histori order tersimpan. Customer sama bisa order berulang tanpa duplikasi.">
        {canEdit && <Button data-testid="btn-add-customer" onClick={() => { setForm(empty); setEditId(null); setOpen(true); }} className="gap-1.5 bg-slate-900 hover:bg-slate-800"><Plus className="w-4 h-4" /> Tambah Customer</Button>}
      </PageHeader>
      <DataTable testId="customers-table" columns={columns} data={rows} searchKeys={["name", "phone", "address"]} exportName="customers" />

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>{editId ? "Edit Customer" : "Tambah Customer"}</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Nama</Label><Input data-testid="customer-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
            <div><Label>No. Telepon</Label><Input data-testid="customer-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="0812..." /></div>
            <div><Label>Alamat</Label><Input data-testid="customer-address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>
          </div>
          <DialogFooter><Button data-testid="save-customer" onClick={save} className="bg-slate-900 hover:bg-slate-800">Simpan</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
